import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper, Typography, useTheme } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { formatCurrency } from '../../lib/utils';

function QuoteView({ quote, onEdit, onSave, fetchCustomers }) {
  const [successModal, setSuccessModal] = useState(false); // Estado para el modal de éxito
  const [errorMessage, setErrorMessage] = useState(''); // Estado para el mensaje de error
  const [errorModal, setErrorModal] = useState(false); // Estado para el modal de error
  const [isSending, setIsSending] = useState(false); // Estado para el envío de cotización
  const theme = useTheme(); // Hook para acceder al tema actual
  const { t, i18n } = useTranslation('config');

  const sendQuote = async () => {
    setIsSending(true);
    console.log('Current language:', i18n.language); // Debug log
    try {
      console.log('Enviando cotización:', quote);
      console.log('quote.id:', quote.id);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/sales/quote/send/${quote.id}`, {
        params: { lang: i18n.language }
      });
      console.log('res:', res);
      if (res.status === 200) {
        // alerta de logro
        toast.success(t('quote.quoteView.quoteSend'));
        //regresar a la vista de cotizaciones
        if (onSave) onSave(); // Llama al método `onSave` para regresar automáticamente
      } else {
        // Handle unexpected success codes if any, or throw generic
        throw new Error(t('quote.quoteView.errorSend'));
      }
    } catch (error) {
      console.error('Error al enviar cotización:', error);
      const msg = error.response?.data?.message || t('quote.quoteView.textError');
      setErrorMessage(msg);
      setErrorModal(true); // Abre el modal de error
    } finally {
      setIsSending(false);
      await fetchCustomers?.();
    }
  };

  const handleCloseSuccessModal = () => {
    setSuccessModal(false); // Cierra el modal de éxito
  };

  const handleCloseErrorModal = () => {
    setErrorModal(false); // Cierra el modal de error
  };

  if (!quote) return null; // Si no hay datos, no renderiza nada

  return (
    <>
      <Paper
        elevation={3}
        style={{
          border: '1px solid #ddd',
          margin: '0 auto',
          maxWidth: '1500px',
          padding: '30px'
        }}
      >
        <Typography style={{ fontSize: '24px', fontWeight: 'bold' }} variant="h5">
          {t('quote.quoteView.quote')}
        </Typography>
        <Typography style={{ fontSize: '20px', marginBottom: '30px' }} variant="subtitle1">
          {quote.propertyName}
        </Typography>
        <Divider style={{ marginBottom: '30px' }} />
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <Typography style={{ fontSize: '20px', fontWeight: 'bold' }} variant="subtitle1">
              {t('quote.quoteView.businnesPartnet')}
            </Typography>
            <Typography style={{ fontSize: '18px' }}>{quote.businessPartner?.name}</Typography>
            <Typography style={{ fontSize: '18px' }}>{quote.businessPartner?.email}</Typography>
            <Typography style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '30px' }} variant="subtitle1">
              {t('quote.quoteView.plan')}
            </Typography>
            <Typography style={{ fontSize: '18px' }}>{quote.planName === 1 ? 'Initial' : quote.planName === 2 ? 'Convenient' : ''}</Typography>
            <Typography style={{ fontSize: '18px', marginTop: '20px' }}>
              {t('quote.quoteView.numberAccesesPoints')}: <strong>{quote.numberOfAccessPoints}</strong>
            </Typography>
            <Typography style={{ fontSize: '18px' }}>
              {t('quote.quoteView.numberUsers')}: <strong>{quote.numberOfUsers}</strong>
            </Typography>
            <Typography style={{ fontSize: '18px' }}>
              {t('quote.quoteView.numberBridge')}: <strong>{quote.bridge}</strong>
            </Typography>
          </Grid>
          <Grid item md={6} style={{ textAlign: 'right' }} xs={12}>
            <Typography style={{ fontSize: '18px' }}>
              <strong>{t('quote.quoteView.priceXUsers')}:</strong> {formatCurrency(quote.pricePerUser)}
            </Typography>
            <Typography
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                marginTop: '20px'
              }}
            >
              {t('quote.totalPrice')}: {formatCurrency(quote.totalPrice)}
            </Typography>
            <div style={{ marginTop: '30px' }}>
              <Button
                color="secondary"
                disabled={quote.status === 'done' || isSending}
                onClick={() => sendQuote()}
                style={{ fontSize: '16px', marginRight: '15px' }}
                variant="contained"
              >
                {isSending ? t('quote.sending') : t(quote.status === 'sent' ? 'quote.quoteView.resend' : 'quote.quoteView.send')}
              </Button>
              {quote.status === 'draft' && (
                <Button
                  onClick={() => onEdit(quote)}
                  style={{
                    borderColor: theme.palette.mode === 'dark' ? '#ffffff' : '#ddd',
                    color: theme.palette.mode === 'dark' ? '#ffffff' : '#333',
                    fontSize: '16px',
                    marginRight: '15px'
                  }}
                  variant="outlined"
                >
                  {t('quote.quoteView.edit')}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>

      {/* Modal de éxito */}
      <Dialog onClose={handleCloseSuccessModal} open={successModal}>
        <DialogTitle>{t('quote.quoteView.textLicense')}</DialogTitle>
        <DialogContent>
          <Typography>{t('quote.quoteView.textTwoLicense')}</Typography>
          <Typography>
            QuoteId de la cotización: <strong>{quote.id}</strong>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleCloseSuccessModal}>
            {t('quote.quoteView.close')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de error */}
      <Dialog onClose={handleCloseErrorModal} open={errorModal}>
        <DialogTitle>{t('quote.quoteView.errorGenerateLicense')}</DialogTitle>
        <DialogContent>
          <Typography>{errorMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleCloseErrorModal}>
            {t('quote.quoteView.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default QuoteView;
